import React, { memo, useEffect } from "react";
import Pages from "@client.enums/pages";
import usePermission from "@client.hooks/usePermission";
import Tabs from "@client.components/Tabs/Tabs";
import { getInsights, makeInsights } from "./reducer";
import { useDispatch, useSelector } from "react-redux";
import { makeFilter } from "@client.components/TopChartFilters/reducer";
import { makeLastViewedInsightsAt } from "@client.pages/Login/reducer";

const NavigationTabs = () => {
  const { isAllowed } = usePermission();
  const notifications = useSelector(makeInsights);
  const dispatch = useDispatch();
  const filter = useSelector(makeFilter);
  const lastViewedInsightsAt = useSelector(makeLastViewedInsightsAt);

  useEffect(() => {
    dispatch(getInsights(filter));
  }, [dispatch, filter]);

  const data = [
    {
      to: Pages.DashboardInsights,
      title: "components.Dashboard.NavigationTabs.insights",
      highlighted: notifications.data.some(
        (n) => n.createdAt >= lastViewedInsightsAt
      ),
    },
    {
      to: Pages.DashboardOwn,
      title: "components.Dashboard.NavigationTabs.mystats",
    },
    {
      to: Pages.DashboardTeam,
      title: "components.Dashboard.NavigationTabs.teamStats",
      hide: !isAllowed(),
    },
  ];
  return <Tabs data={data} />;
};

export default memo(NavigationTabs);
